import { render, staticRenderFns } from "./priceConfirmPop.vue?vue&type=template&id=7f1dd857&scoped=true"
import script from "./priceConfirmPop.vue?vue&type=script&lang=js"
export * from "./priceConfirmPop.vue?vue&type=script&lang=js"
import style0 from "./priceConfirmPop.vue?vue&type=style&index=0&id=7f1dd857&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1dd857",
  null
  
)

export default component.exports